(function () {
	angular
		.module('trackeye')
		.controller('RenewController', RenewController);

	RenewController.$inject = ["$scope", "$state", "AppFactory", "DeviceService", "AccountService", "NotificationService", "ModalService"];

	function RenewController($scope, $state, app, DeviceService, AccountService, NotificationService, ModalService) {
		var modal_scope = $scope.$parent;
		var vm = this;

		vm.renewForm = {};

		vm.app = app;
		vm.loading = false;
		vm.device = modal_scope.device;
		vm.account = AccountService.get();

		var depositModal = ModalService.create('deposit', modal_scope.subCtrl);

		vm.openDepositModal = function() {
			modal_scope.subCtrl.suggestDepositAmount(
				vm.getPlanById(vm.planId),
				vm.priceOptions
			);

			depositModal.open();
			modal_scope.close();
		}

		if (!vm.device.nodeid) {
			$scope.$on('DeviceService.initialized', function () {
				vm.device = DeviceService.find($state.params.nodeid);
				vm.priceOptions = DeviceService.prices(vm.device);
			});
		} else {
			vm.priceOptions = DeviceService.prices(vm.device);
		}

		vm.getPriceWithVat = function (plan) {
			var vatDecimal = (vm.priceOptions.vatcode / 10000) + 1;
			return plan.price * vatDecimal;
		};

		vm.startSubscription = function () {
			if (!hasBillingData(vm.account)) {
				NotificationService.warning('STR_ACCOUNT_INFORMATION_MISSING');
				return;
			}

			if (vm.planId) {
				var plan = vm.getPlanById(vm.planId);

				if (getPriceWithVat(vm.planId) > vm.account.balance) {
					vm.renewForm.$setValidity('amount', false);
					vm.loading = false;
				} else {
					vm.loading = true;
					DeviceService.startAppSubscription(vm.account, vm.device, vm.planId)
						.then(function () {
							vm.device.setActive(true);

							// Ugly check, to avoid setting the recurring value to same,
							// which will trigger an 409 on the backend.
							// @todo make pretty pls
							if (angular.isDefined(vm.renew)) {
								DeviceService.recurringAppSubscription(vm.device, vm.renew);
							}
							vm.account.balance -= getPriceWithVat(vm.planId);

							modal_scope.close();
							NotificationService.info("STR_NOTICE_DEVICE_ACTIVE", {
								"name": vm.device.getName() || vm.device.getNodeId()
							});
						}, function (xhr) {
							if (xhr.is50x()) {
								// @todo C4api returns 500, if something errors when withdrawing amount.
								// So this will be interpreted as a backend error, as of now
								NotificationService.danger("STR_ERROR_NOTICE_SERVER");
								console.warn(xhr.getResponseData());
								modal_scope.close();
							} else {
								vm.renewForm.$setValidity('amount', false);
							}
						}).finally(function () {
							vm.loading = false;
						});
				}
			} else {
				if (angular.isDefined(vm.renew)) {
					DeviceService.recurringAppSubscription(vm.device, vm.renew);
					modal_scope.close();
				}
				vm.loading = false;
			}
		};

		vm.getPlanById = function (planId) {
			for (var i = 0; i < vm.priceOptions.prices.length; i++) {
				if (planId == vm.priceOptions.prices[i].item_id) {
					return vm.priceOptions.prices[i];
				}
			}
			return null;
		};

		vm.transformTol10nStr = function (str) {
			return "STR_" + str.replace(/\W/g, "_").toUpperCase();
		};

		/**
		 * Asserts if the account, has all the needed billing data.
		 * @param {Account} account
		 * @returns {boolean}
		 */
		function hasBillingData(account) {
			return (
				account.getName() &&
				account.getStreet() &&
				account.getTown() &&
				account.getZip()
			);
		}

		function getPriceWithVat(planId) {
			var vat = (vm.priceOptions.vatcode / 10000) + 1,
				plan = vm.getPlanById(planId);

			return Math.abs(plan.price * vat);
		}
	}
}());